import React from 'react';

import { Box, Divider, Link, Paper, Stack, Typography } from '@mui/material';

import { ChatterFieldChange } from './types';

const BLANK_VALUE = 'blank';

interface Props {
  changes: Array<ChatterFieldChange>;
  moreUpdateCount: number;
  salesforceUrl?: string;
}

export default function ChatterFieldChanges({ changes, moreUpdateCount, salesforceUrl }: Props) {
  return (
    <Paper variant="outlined" sx={{ mt: 1.5 }}>
      <Stack spacing={1.5} p={1.5}>
        {changes.map((change, index) => (
          <Box key={`${change.field}-${index}`}>
            <Typography variant="body2" color="text.secondary">
              {change.field}
            </Typography>
            <Typography variant="body2">
              {change.oldValue ?? BLANK_VALUE} to {change.newValue ?? BLANK_VALUE}
            </Typography>
          </Box>
        ))}
      </Stack>
      {moreUpdateCount > 0 && salesforceUrl && (
        <>
          <Divider />
          <Box py={1} textAlign="center">
            <Link href={salesforceUrl} target="_blank" rel="noopener noreferrer" variant="body2">
              Show All Updates
            </Link>
          </Box>
        </>
      )}
    </Paper>
  );
}
